import React from 'react';
import DepartmentTemplate from './DepartmentTemplate';

const DeptHautsDeSeine92 = () => {
  return (
    <DepartmentTemplate
      department="Hauts-de-Seine"
      departmentNumber="92"
      cities="Nanterre, Boulogne-Billancourt, Courbevoie, Levallois-Perret"
      region="Île-de-France"
    />
  );
};

export default DeptHautsDeSeine92;
